import Http from './base';
import { BASE_URL, MY_DATA, VENDER_BASE_URL } from './base/constants';

export function getMyData(): Promise<User> {
  return Http.get(`${BASE_URL}${MY_DATA}`);
}

export function getStateCities(state: string): Promise<City[]> {
  return Http.get(`${VENDER_BASE_URL}/pf/api/v1/localizacao/uf/${state}/cidades`, {
    baseURL: BASE_URL
  });
}

export function getZipCode(zipCode: string): Promise<CEP> {
  return Http.get(`${VENDER_BASE_URL}/pf/api/v1/localizacao/cep/${zipCode}`);
}

function createUserData(data: Partial<User>): Promise<void> {
  return Http.post(`${BASE_URL}${MY_DATA}`, data, {
    headers: { ContentType: 'application/json' }
  });
}

function updateUserData(data: Partial<User>): Promise<void> {
  return Http.put(`${BASE_URL}${MY_DATA}/${data.id}`, data, {
    headers: { ContentType: 'application/json' }
  });
}

export function saveUserData({
  data,
  type
}: {
  data: Partial<User>;
  type: 'post' | 'put';
}): Promise<void> {
  if (type === 'post') return createUserData(data);
  return updateUserData(data);
}

export interface Optin {
  id: number;
  nome: string;
  descricao: string;
  status: boolean;
}

export interface User {
  id: number;
  nome: string;
  email: string;
  cpf: string | null;
  telefone: string | null;
  celular: string | null;
  endereco: string | null;
  bairro: string | null;
  cidadeId: number | null;
  cidadeNome: string | null;
  ufId: string | null;
  ufNome: string | null;
  cep: string | null;
  dataNascimento: number | null;
  sexo: string | null;
  optins: Optin[];
  mostrarTelefone: boolean | null;
}

export interface City {
  id: number;
  nome: string;
  uf: string;
}

export interface CEP {
  cityDescription?: string;
  cityId?: number;
  district?: string;
  latitude?: number;
  longitude?: number;
  streetAddress?: string;
  uf?: string;
  zipCode: string;
}
